// extracted by mini-css-extract-plugin
export default {"sponsor":"SponsorItem_sponsor__MgUUG","img":"SponsorItem_img__bR4mH"};